import { render, staticRenderFns } from "./UsaFlag.vue?vue&type=template&id=2b51c0a0"
import script from "./UsaFlag.vue?vue&type=script&lang=js"
export * from "./UsaFlag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports